import { useSearchParams } from "../../../../../hook/use-search-params";
import { configPermission } from "../../../../../constants/configPermission";
import { EmployeeRoleService } from "../../../../../services/config/permission-config/employeeRole";
import { useUser } from "../../../../../hook";
import { useQuery } from "@tanstack/react-query";

export const useCheckPermission = (permissionId: configPermission) => {
  const { searchParams } = useSearchParams();
  const { email } = useUser();
  const configId = searchParams.get("configId") || "1";

  const { data } = useQuery({
    queryKey: ["check-permisison", configId, permissionId],
    queryFn: () => EmployeeRoleService.checkEmployeeHavePermission(email?.toLowerCase(), configId, permissionId),
  });

  return data;
};
